import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=0256a9f2"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=0256a9f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports